import AdminViewMedicalHistory from '@brands/Dashboard/MedicalHistory/AdminView/MedicalHistory/MedicalHistory';
import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '../../../hooks/useReduxHook';
import { UserRoleName } from '../../../services/identity/types/UserProfile';
import MedicalHistory from './MedicalHistory';

const MedicalHistoryValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);
  const { pathname } = useLocation();
  const isIntakeRecapRoute = pathname.toLowerCase().includes('/clinical-data/recap');

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor:
      component = <MedicalHistory />;
      break;
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      component = isIntakeRecapRoute ? <MedicalHistory /> : <AdminViewMedicalHistory />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default MedicalHistoryValidation;
